module.exports = __webpack_public_path__ + "img/score50.f063973b.png";